// src/pages/dashboard/AccountPage.tsx
import AccountProfileTab from './account/AccountProfileTab';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export default function AccountPage() {
  const { user, loading: authLoading } = useAuth(); 

  if (authLoading) {
    return (
      <div className="flex justify-center items-center h-full">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="ml-2">Loading account details...</p>
      </div>
    );
  }

  if (!user) {
    return <p>Please log in to view your account details.</p>;
  }
  
  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <h1 className="text-2xl font-bold text-slate-headline mb-6">Account Settings</h1>
      <AccountProfileTab />
    </div>
  );
}